export const EXCMCYCLICTASK_SHOW_RESET = 'EXCMCYCLICTASK_SHOW_RESET'
export const EXCMCYCLICTASK_SHOW_SET_ERROR = 'EXCMCYCLICTASK_SHOW_SET_ERROR'
export const EXCMCYCLICTASK_SHOW_SET_RETRIEVED = 'EXCMCYCLICTASK_SHOW_SET_RETRIEVED'
export const EXCMCYCLICTASK_SHOW_TOGGLE_LOADING = 'EXCMCYCLICTASK_SHOW_TOGGLE_LOADING'
